(() => {
  const configCarrier = document.querySelector('[name=config]');
  const htmlConfig = configCarrier.getAttribute('content') || '{}';

  // Read out the value JSON-encoded into body::before via SASS
  window.park = Object.assign({}, window.park, {
    exports: {
      brandColor: '#ffbe00',
      containerWidth: '980',
      globalSpacing: '15',
      mediaqueries: {
        handheld: 'handheld',
        mobile: 'screen and (max-width: 48em)',
        desktop: 'screen and (min-width: 48.0625em)',
        larger: 'screen and (min-width: 71.9375em)',
        large: 'screen and (min-width: 60.625em)',
      },
    },
  });

  window.park.exports.config = JSON.parse(htmlConfig);
  window.park.exports.config.appMode = window.park.exports.config.isApp;
})();
